import { AttributeSplitNodeData, SplitValue } from 'modules/workflows/types';

export const getHasDefaultSplit = (splitValues: SplitValue[]) =>
  !!splitValues.find((split) => split.isDefault);

export const getUniqueListBy = <T extends Record<string, unknown>>(arr: T[], key: string) => {
  return [
    ...arr
      .reduce((map, obj) => {
        return map.set(obj[key], obj);
      }, new Map())
      .values(),
  ];
};

/**
 * Get comparable values from a given AttributeSplitEditor nodeData object.
 * - Only returns fields that are affected by UI changes
 *
 * @param { Object } data
 * @returns comparable nodeData object
 */
export const getAttributeSplitEditorNodeDataToBeCompared = (
  data: Pick<AttributeSplitNodeData, 'field' | 'splitValues'>,
) => ({
  field: data?.field ?? undefined,
  splitValues: data?.splitValues ?? undefined,
});
